import toc from './toc.js';
import './toc.scss';

export default toc;
